import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Lock } from "lucide-react";
import { BUSINESS, NAV_LINKS, SERVICES } from "@/data/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-5 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <img src="/logo.png" alt="Crawford Construction logo" className="h-16 w-16 object-contain rounded-full ring-2 ring-gold/60 bg-white mb-4" />
          <p className="text-white/60 text-sm leading-relaxed">
            Belize-based construction & development, delivering quality craftsmanship for {BUSINESS.years} years.
          </p>
        </div>

        <div>
          <h4 className="text-gold text-xs tracking-[0.2em] uppercase font-bold mb-5">Navigate</h4>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-white/70 hover:text-gold text-sm transition-colors">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-gold text-xs tracking-[0.2em] uppercase font-bold mb-5">Services</h4>
          <ul className="space-y-3">
            {SERVICES.slice(0, 5).map((s) => (
              <li key={s.key}><Link to="/services" className="text-white/70 hover:text-gold text-sm transition-colors">{s.title}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-gold text-xs tracking-[0.2em] uppercase font-bold mb-5">Contact</h4>
          <ul className="space-y-4 text-sm text-white/70">
            <li className="flex gap-3"><MapPin size={18} className="text-gold shrink-0" /> {BUSINESS.address}</li>
            <li className="flex gap-3"><Phone size={18} className="text-gold shrink-0" /> <a href={BUSINESS.phoneHref} className="hover:text-gold">{BUSINESS.phone}</a></li>
            <li className="flex gap-3"><Mail size={18} className="text-gold shrink-0" /> <a href={`mailto:${BUSINESS.email}`} className="hover:text-gold break-all">{BUSINESS.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 py-6 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} {BUSINESS.name} All rights reserved.</p>

          <a
            href="https://www.ubuntu-markets.org"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="built-by-link"
            className="flex items-center gap-2 text-white/50 hover:text-white transition-colors group order-last sm:order-none"
          >
            <span className="tracking-wide">Built by</span>
            <img
              src="/built-by-ubuntu.png"
              alt="Ubuntu Market"
              className="h-10 w-auto opacity-80 group-hover:opacity-100 transition-opacity"
            />
          </a>

          <Link
            to="/admin/login"
            data-testid="footer-admin-link"
            className="flex items-center gap-2 text-white/70 hover:text-gold border border-white/20 hover:border-gold px-4 py-2 rounded-full transition-colors sm:mr-40"
          >
            <Lock size={13} /> Staff / Admin Login
          </Link>
        </div>
      </div>
    </footer>
  );
};
